function unCamelCase(source, delimiter = " ") {
  return source.replace(/([a-z\xE0-\xFF])([A-Z\xC0\xDF])/g, `$1${delimiter}$2`).toLowerCase();
}
import { validateTidalLicense } from "../../base/index.js";
validateTidalLicense();
export {
  unCamelCase
};
//# sourceMappingURL=unCamelCase.js.map
